import React from "react";
import PropTypes from "prop-types";
import { Form, Text } from "informed";
import { connect } from "react-redux";
import { validatePasscode } from "validators/validators";
import { FormattedMessage, injectIntl } from "react-intl";
import RFEAlert from "../../../components/EYTopNavBar/assets/RFE-alert.svg";
import "../../rfetheme.scss";
import {
  selectValidPassCodeLink,
  sendPassCodeRes,
  selectValidLink
} from "AuthorizeLink/selectors";
import config from "config";
const mapStateToProps = state => {
  return {
    validPassCode: selectValidPassCodeLink(state),
    sendPassCodeRes: sendPassCodeRes(state),
    selectValidLink: selectValidLink(state)
  };
};
class RFEPassCodeAuthentication extends React.Component {
  static propTypes = {
    actionData: PropTypes.object,
    validPassCode: PropTypes.object,
    sendPassCodeRes: PropTypes.object,
    handlePassCodeValidate: PropTypes.func,
    intl: PropTypes.object,
    selectValidLink: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.hitcount = 0;
    this.state = {
      showResendError: false,
      showResendSuccess: false,
      disableAccess: false
    };
  }
  isResentCode = false;
  /**Triggers passcode validation function */
  handlePassCodeValidate = event => {
    event.preventDefault();
    this.formApi.submitForm();
    if (!this.formApi.getState().invalid) {
      this.props.handlePassCodeValidate(this.formApi.getValue("email"));
      this.hitcount = this.hitcount + 1;
      if (this.hitcount > config.accessCodeRetries) {
        this.setState({
          disableAccess: true
        });
      }
    }
  };
  /**Email validation and passcode request */
  handleSendPassCode = () => {
    this.props.handleSendPassCode();
    this.isResentCode = true;
    window.setTimeout(() => {
      this.setState({
        showResendSuccess: true
      });
    }, 2000);

    window.setTimeout(() => {
      this.setState({
        showResendSuccess: false,
        showResendError: false
      });
    }, 10000);
  };

  handleValidatePasscode = (value, intl) =>
  {
    const result = validatePasscode(value, intl);
    if (result !== null)
      return result;
  }

  /**Renders message after resend button was clicked */
  renderResendSuccess = successStatus => {
    if (!successStatus) return "";
    return (
      <div className="field">
        <div
          className="control error-response-wrapper"
          style={{
            color: "green"
          }}
        >
          <FormattedMessage
            id={
              "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.resend-code.success.message"
            }
          />
        </div>
      </div>
    );
  };
  /**Renders error message */
  renderResendError = errorStatus => {
    if (!errorStatus) return "";
    return (
      <div className="field">
        <div
          className="control error-response-wrapper"
          style={{
            backgroundImage: "url(" + RFEAlert + ")"
          }}
        >
          <FormattedMessage
            id={
              "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.resend-code.error.message"
            }
          />
        </div>
      </div>
    );
  };
  /**Reload to accessLink step */
  redirectToAccessLink = () => {
    window.location.reload();
  };
  /**Returns background image component */
  SetBackgroundImage = path => {
    return { backgroundImage: "url(" + path + ")" };
  };
  /**Returns AccessLink step or passcode resend */
  resendContent = hitCount => {
    if (hitCount > config.accessCodeRetries) {
      return (
        <p>
          <br />
          <a
            id="request-access-link"
            title={this.props.intl.formatMessage({
              id:
                "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.request-access.link"
            })}
            onClick={() => this.redirectToAccessLink()}
          >
            <FormattedMessage
              id={
                "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.request-access.link"
              }
            />
          </a>
        </p>
      );
    } else {
      return (
        <p>
          <FormattedMessage
            id={
              "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.placeholder"
            }
          />
          <a
            id="resend-code"
            title={this.props.intl.formatMessage({
              id:
                "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.resend-wrapper.link"
            })}
            onClick={() => this.handleSendPassCode()}
            style={{ marginLeft: "5px" }}
          >
            <FormattedMessage
              id={
                "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.resend-wrapper.link"
              }
            />
          </a>
        </p>
      );
    }
  };
  /**Returns error message in case passcode is invalid or expired */
  renderError = () => {
    // console.log(this.props);

    if (!_.isEmpty(this.props.validPassCode)) {
      if (this.props.validPassCode.valid && !this.props.validPassCode.expired) {
        return "";
      } else if (
        !this.props.validPassCode.valid &&
        this.props.validPassCode.expired
      ) {
        return (
          <div className="field">
            <div
              className="control error-response-wrapper"
              style={{
                backgroundImage: "url(" + RFEAlert + ")"
              }}
            >
              <FormattedMessage
                id={
                  "AuthorizeLink.components.RFEPassCodeAuthentication.validatePassCode.Toaster.expired.error"
                }
              />
            </div>
          </div>
        );
      } else if (
        !this.props.validPassCode.valid &&
        !this.props.validPassCode.expired &&
        this.props.validPassCode.actionId == 0
      ) {
        return "";
      } else {
        if (this.hitcount > config.accessCodeRetries) {
          return (
            <div className="field">
              <div
                className="control error-response-wrapper"
                style={this.SetBackgroundImage(RFEAlert)}
              >
                <FormattedMessage
                  id={
                    "AuthorizeLink.components.RFEPassCodeAuthentication.validatePassCode.Toaster.limit.invalid.error"
                  }
                />
              </div>
            </div>
          );
        } else {
          return (
            <div className="field">
              <div
                className="control error-response-wrapper"
                style={this.SetBackgroundImage(RFEAlert)}
              >
                <FormattedMessage
                  id={
                    "AuthorizeLink.components.RFEPassCodeAuthentication.validatePassCode.Toaster.invalid.error"
                  }
                />
              </div>
            </div>
          );
        }
      }
    } else {
      return "";
    }
  };
  /**Defines this.formApi */
  setFormApi = formApi => {
    this.formApi = formApi;
  };
  render() {
    const intl = this.props.intl;
    const { showResendSuccess, showResendError, disableAccess } = this.state;
    const { sendPassCodeRes, selectValidLink } = this.props;
    const accessCode = this.isResentCode ? sendPassCodeRes : selectValidLink;
    return (
      <React.Fragment>
        <Form id="state-form" getApi={this.setFormApi}>
          {() => (
            <div className="columns">
              <div className="column">
                <div className="card">
                  <div className="form-group">
                    <div className="card-content">
                      <div className="MLA-emailTitle">
                        <label htmlFor="email">
                          <FormattedMessage
                            id={
                              "AuthorizeLink.components.RFEPassCodeAuthentication.index.form"
                            }
                          />
                        </label>
                      </div>
                      <Text
                        id="input-text-email"
                        className={
                          this.formApi.getError("email")
                            ? "input is-danger"
                            : "input"
                        }
                        style={{ width: "285px !important" }}
                        field="email"
                        autoFocus
                        type="text"
                        placeholder={
                          intl.formatMessage({
                            id:
                              "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.placeholder"
                          }) +
                          ((accessCode.partialCode || "").length > 0
                            ? " " + (accessCode.partialCode || "") + "XXXXXX"
                            : "")
                        }
                        maxLength={
                          (accessCode.partialCode || "").length > 0 ? 9 : 9
                        }
                        validate={value => this.handleValidatePasscode(value, intl)}
                        validateOnBlur
                        validateOnChange
                      />
                      <div className="is-grouped">
                        <p className="help is-danger">
                          {this.formApi.getError("email")}
                        </p>
                      </div>
                      
                      {/* to show error message */}
                      {this.renderError()}

                      {/* to show error and success messages for resend feature */}
                      {this.renderResendSuccess(showResendSuccess)}
                      {this.renderResendError(showResendError)}

                      <div className="is-grouped passcode-button">
                        <div className="resend-wrapper">
                          {this.resendContent(this.hitcount)}
                        </div>
                        <p className="help is-danger" />
                        <p className="control">
                          <button
                            id="button-validate"
                            className="button is-new-primary"
                            disabled={disableAccess ? true : false}
                            onClick={event =>
                              this.handlePassCodeValidate(event)
                            }
                          >
                            <FormattedMessage
                              id={
                                "AuthorizeLink.components.RFEPassCodeAuthentication.index.form.button.access"
                              }
                            />
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Form>
      </React.Fragment>
    );
  }
}
RFEPassCodeAuthentication.propTypes = {
  /**Action general information */
  actionData: PropTypes.object,
  /**Triggers redux functions */
  dispatch: PropTypes.func,
  /**Function to request passcode validation  */
  handlePassCodeValidate: PropTypes.func,
  /**Triggers function to send passcode email */
  handleSendPassCode: PropTypes.func,
  /**Object containing passcode validation response */
  sendPassCodeRes: PropTypes.object,
  /**Project language and type */
  settings: PropTypes.object,
  /**Object containing the passcode properties */
  validPassCode: PropTypes.object
};

export default connect(mapStateToProps)(injectIntl(RFEPassCodeAuthentication));
